var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "modal fade",
        { show: _vm.isShowAddReference, "d-block": _vm.isShowAddReference },
      ],
      staticStyle: { display: "block" },
      attrs: { id: "go-add-reference", "aria-hidden": "true", tabindex: "-1" },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoadingCheckCrawData,
              expression: "!isLoadingCheckCrawData",
            },
          ],
          staticClass: "modal-dialog go-modal-resource-add",
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("div", { staticClass: "modal-title" }, [
                _vm._v(_vm._s(_vm.$t("popupAddReference.title"))),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon close",
                  attrs: { "data-dismiss": "modal", type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.handleClosePopUp()
                    },
                  },
                },
                [_c("i", { staticClass: "go-icon-20 go-icon-close" })]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("ul", { staticClass: "nav go-tab-line" }, [
                _c("li", { staticClass: "go-tab-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "go-tab-link",
                      attrs: {
                        id: _vm.REFERENCE_TAB_SELECT.FILES,
                        "data-target": "#go-add-upload",
                        "data-toggle": "tab",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("popupAddReference.filesTab.title")))]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "go-tab-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "go-tab-link active",
                      attrs: {
                        id: _vm.REFERENCE_TAB_SELECT.SEARCH,
                        "data-target": "#go-add-search",
                        "data-toggle": "tab",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("popupAddReference.searchTab.title"))
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "go-tab-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "go-tab-link",
                      attrs: {
                        id: _vm.REFERENCE_TAB_SELECT.URL,
                        "data-target": "#go-add-url",
                        "data-toggle": "tab",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("popupAddReference.urlTab.title")))]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "go-tab-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "go-tab-link",
                      attrs: {
                        id: _vm.REFERENCE_TAB_SELECT.NOTE,
                        "data-target": "#go-add-note",
                        "data-toggle": "tab",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("popupAddReference.noteTab.title")))]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "go-tab-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "go-tab-link",
                      attrs: {
                        id: _vm.REFERENCE_TAB_SELECT.MY_SCRAP,
                        "data-target": "#go-add-my-scrap",
                        "data-toggle": "tab",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("popupAddReference.myScrapTab.title"))
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tab-content tab-content-main" }, [
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    attrs: { id: "go-add-upload" },
                  },
                  [_c("refFile")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade show active",
                    attrs: { id: "go-add-search" },
                  },
                  [_c("refSearchComponent")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tab-pane fade", attrs: { id: "go-add-url" } },
                  [_c("refUrl")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    attrs: { id: "go-add-note" },
                  },
                  [_c("refNodeComponent")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    attrs: { id: "go-add-my-scrap" },
                  },
                  [_c("reMyScrap")],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c("refReferenceComponent", {
                  attrs: { "is-loading": _vm.isLoading },
                  on: {
                    addToReferenceDocuments: _vm.tryAddToReferenceDocuments,
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isLoadingCheckCrawData,
              expression: "isLoadingCheckCrawData",
            },
          ],
          staticClass: "modal-dialog go-modal-alert",
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-body" }, [
              _c(
                "div",
                {
                  staticClass: "go-icon-wrap",
                  staticStyle: { "margin-bottom": "10px" },
                },
                [
                  !_vm.isShowResultCheckCrawData
                    ? _c(
                        "div",
                        { staticClass: "go-animation go-loader-animation" },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "go-loader-svg",
                              attrs: { viewBox: "0 0 50 50" },
                            },
                            [
                              _c("circle", {
                                staticClass: "loader-circle bg",
                                attrs: { cx: "25", cy: "25", r: "23" },
                              }),
                              _vm._v(" "),
                              _c("circle", {
                                staticClass: "loader-circle animate",
                                attrs: { cx: "25", cy: "25", r: "23" },
                              }),
                            ]
                          ),
                        ]
                      )
                    : !_vm.isCancelCrawData
                    ? _c("i", { staticClass: "go-icon-54 go-icon-file-check" })
                    : _vm.isCancelCrawData
                    ? _c(
                        "div",
                        { staticClass: "go-animation go-success-animation" },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "50",
                                height: "50",
                                viewBox: "0 0 50 50",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("circle", {
                                staticClass: "cancel-circle",
                                attrs: {
                                  cx: "25",
                                  cy: "25",
                                  r: "24",
                                  fill: "none",
                                  stroke: "red",
                                  "stroke-width": "2",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                staticClass: "cancel-cross",
                                attrs: {
                                  fill: "none",
                                  stroke: "red",
                                  "stroke-width": "2",
                                  d: "M15 15l20 20M15 35l20-20",
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              !_vm.isShowResultCheckCrawData
                ? _c("p", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "popupAddReference.loadingCrawDataModal.collectingMessage"
                          )
                        )
                    ),
                    _c("br"),
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "popupAddReference.loadingCrawDataModal.waitMessage"
                        )
                      ) + "\n        "
                    ),
                  ])
                : !_vm.isCancelCrawData
                ? _c("p", { staticClass: "lead" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "popupAddReference.loadingCrawDataModal.completedMessage"
                        )
                      )
                    ),
                  ])
                : _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "popupAddReference.loadingCrawDataModal.cancelMessage"
                        )
                      )
                    ),
                  ]),
              _vm._v(" "),
              !_vm.isCancelCrawData
                ? _c("div", { staticClass: "go-info-box" }, [
                    _c("ul", { staticClass: "go-info-list" }, [
                      _c("li", { staticClass: "go-list-item" }, [
                        _c("em", { staticClass: "go-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "popupAddReference.loadingCrawDataModal.totalDocument"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("strong", { staticClass: "go-dark" }, [
                          _vm._v(
                            _vm._s(_vm.numberTotalDocumentsCheckCrawData || 0)
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "go-list-item" }, [
                        _c("em", { staticClass: "go-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "popupAddReference.loadingCrawDataModal.completedDocument"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("strong", { staticClass: "go-success" }, [
                          _vm._v(
                            _vm._s(_vm.documentsHaveContentList.length || 0)
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "go-list-item" }, [
                        _c("em", { staticClass: "go-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "popupAddReference.loadingCrawDataModal.failureDocument"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.isShowResultCheckCrawData
                          ? _c("strong", { staticClass: "go-danger" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.numberTotalDocumentsCheckCrawData -
                                    _vm.documentsHaveContentList.length || 0
                                )
                              ),
                            ])
                          : _c("strong", { staticClass: "go-danger" }, [
                              _vm._v(" 0 "),
                            ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              !_vm.isShowResultCheckCrawData
                ? _c(
                    "button",
                    {
                      staticClass: "btn go-btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleClickCancelCrawData.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "popupAddReference.loadingCrawDataModal.cancel"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm.isShowResultCheckCrawData
                ? _c(
                    "button",
                    {
                      staticClass: "btn go-btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleConfirm.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "popupAddReference.loadingCrawDataModal.confirm"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }